/**
 * Parses a tailwind size to a pixel value.
 * @param size - The tailwind size to parse.
 * @returns The pixel value.
 */
export const tailwindSizeToPixels = (size: `w-${number}` | `h-${number}`) => {
  return parseInt(size.split("-")[1]) * 4;
};
